import React, { useEffect, useState } from "react";
import axios from "axios";
import { saveToken } from "../utils/tokenStorage";
import { LifeBuoy, Loader2, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

/** Entrada de suporte: troca o ticket gerado no CRM por uma sessao da loja.
 *  O ticket vale uma vez so e por 2 minutos — o link nao serve pra guardar. */
export default function SuporteEntrar({ setIsAuthenticated }) {
  const [erro, setErro] = useState("");

  useEffect(() => {
    const ticket = new URLSearchParams(window.location.hash.split("?")[1] || "").get("ticket");
    if (!ticket) {
      setErro("Link de suporte incompleto. Gere outro no CRM.");
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/suporte/entrar`, { ticket });
        saveToken(data.access_token);
        if (data.user) localStorage.setItem("user", JSON.stringify(data.user));
        setIsAuthenticated?.(true);
        // troca a URL antes de entrar pra o ticket nao ficar no historico
        window.location.replace(`${window.location.pathname}#/`);
        window.location.reload();
      } catch (e) {
        setErro(e?.response?.data?.detail || "Não foi possível entrar. Gere outro link no CRM.");
      }
    })();
  }, [setIsAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="max-w-sm w-full text-center">
        {erro ? (
          <>
            <div className="w-14 h-14 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-7 h-7 text-red-500" />
            </div>
            <h1 className="text-lg font-bold text-foreground mb-1">Acesso de suporte</h1>
            <p className="text-sm text-muted-foreground">{erro}</p>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-orange-500/10 flex items-center justify-center mx-auto mb-4">
              <LifeBuoy className="w-7 h-7 text-orange-500" />
            </div>
            <h1 className="text-lg font-bold text-foreground mb-1">Entrando como suporte…</h1>
            <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" /> validando o link
            </p>
          </>
        )}
      </div>
    </div>
  );
}
